import {
  login,
  logout,
  getToken,
  requestResetPassword,
  resetPassword,
} from '@/services/auth';
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  GET_TOKEN,
  LOADING,
  LOADING_SUCCESS,
} from './mutation-types';


const auth = {
  state: {
    token: '',
    refreshToken: '',
    userId: '',
    businessId: '',
  },
  mutations: {
    [LOGIN](state) {
      state.status = 'loading';
    },
    [LOGIN_SUCCESS](state, authData) {
      state.token = authData.jwt;
      state.refreshToken = authData.refresh_token;
      state.userId = authData.id;
      [state.businessId] = authData.business_ids;
    },
    [LOGOUT](state) {
      state.token = '';
      state.refreshToken = '';
      state.userId = '';
      state.businessId = '';
    },
    [GET_TOKEN](state, authData) {
      state.token = authData.jwt;
    },
  },
  actions: {
    login({ commit }, { email, password }) {
      return new Promise((resolve, reject) => {
        commit(LOADING); // show spinner
        return login(email, password)
          .then((res) => {
            const { data } = res;
            if (!data || !data.jwt) {
              const err = new Error('No data in response');
              reject(err);
            } else {
              commit(LOADING_SUCCESS);
              commit(LOGIN_SUCCESS, data);
              resolve(res);
            }
          })
          .catch(({ response }) => {
            commit(LOADING_SUCCESS);
            if (!response) {
              return reject(new Error('Could not connect to server.'));
            }
            const { data } = response;
            if (data.error) {
              return reject(data.error);
            }
            return reject(new Error('Login unsuccessful.'));
          });
      });
    },

    clearState({ dispatch }) {
      return new Promise((resolve) => {
        dispatch('clearAppointments');
        dispatch('clearAppointmentTypes');
        dispatch('clearBusinessInfo');
        dispatch('clearBooking');
        resolve();
      });
    },

    logout({ commit }) {
      return new Promise((resolve, reject) =>
        logout().then((res) => {
          commit(LOGOUT);
          commit(LOADING_SUCCESS);
          resolve(res);
        }).catch(err => reject(err)));
    },

    getToken({ commit }) {
      return new Promise((resolve, reject) =>
        getToken()
          .then((res) => {
            const { data } = res;
            if (!data || !data.jwt) {
              const err = new Error('No data in response');
              reject(err);
            } else {
              commit(GET_TOKEN, data);
              resolve(res);
            }
          }).catch((err) => {
            reject(err);
          }));
    },
    requestResetPassword({ commit }, email) {
      return new Promise((resolve, reject) => {
        commit(LOADING);
        requestResetPassword(email)
          .then((res) => {
            commit(LOADING_SUCCESS);
            resolve(res);
          })
          .catch(({ response }) => {
            commit(LOADING_SUCCESS);
            const { data } = response;
            const error = data.error || data.Error;
            if (error) {
              return reject(error);
            }
            return reject(new Error('Password reset request failed.'));
          });
      });
    },
    resetPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        resetPassword(payload)
          .then((res) => {
            commit(LOADING_SUCCESS);
            resolve(res);
          })
          .catch(({ response }) => {
            commit(LOADING_SUCCESS);
            const { data } = response;
            const error = data.error || data.Error;
            if (error) {
              return reject(error);
            }
            return reject(new Error('Unable to reset password.'));
          });
      });
    },
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    userId: state => state.userId,
  },
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/auth.js